// extracted by mini-css-extract-plugin
export default {"Icon":"rJy6z1CP","IconContainer":"BCs8_2mD","ButtonPlaceholder":"IGZqsWPu","ButtonSkeleton":"aonHMpWg","IconPlaceholder":"Un1dCRMn","Error":"xiG78fj6"};